/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import {BLOCK_HEIGHT} from './constants';

export const Title = styled(Typography)(({theme}) => ({
  fontWeight: 500,
  fontSize: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: theme.spacing(6, 0, 4, 0),
}));

export const AdditionalText = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  color: theme.palette.figma_gray_middle_dark?.main,
  marginTop: '16px',
  lineHeight: '18px',
  marginBottom: theme.spacing(4),
}));

interface WidgetContainerProps {
  isCenterContent?: boolean;
}

export const WidgetContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isCenterContent',
})<WidgetContainerProps>(({theme, isCenterContent}) => ({
  height: BLOCK_HEIGHT,
  minWidth: 'max-content',

  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: isCenterContent ? 'center' : 'flex-start',
  position: 'relative',
}));
